import React, { Component } from 'react';
import classnames from 'classnames';
import { NavLink } from 'react-router-dom';

import { Container } from 'components/grid/Container';
import { Row } from 'components/grid/Row';
import { Col } from 'components/grid/Col';

import GDStyles from 'components/mgm/GiftsAndDiscounts.module.scss';

import { Discount } from 'components/icons/Discount';
import { Discount2 } from 'components/icons/Discount2';
import { TagGift } from 'components/icons/TagGift';
import { Glampoints } from 'components/icons/Glampoints';
import { ExecuteRequest } from 'core/glambox/GlamboxApi';
import { GlamboxEndpoints } from 'core/glambox/GlamboxEndpoints';

const SECONDS_DAY = 86400;
const SECONDS_HOUR = 3600;

class ToYou extends Component {
  render() {
    let factor = 1;

    if (this.props.badge !== null) {
      switch (this.props.badge.badgeId) {
        case 2:
          factor = 1.25;
          break;
        case 3:
          factor = 1.5;
          break;
        case 4:
          factor = 1.75;
          break;
        case 5:
        case 6:
        case 7:
        case 8:
        case 9:
        case 10:
          factor = 2;
          break;
        default:
          factor = 1;
          break;
      }
    }

    let points = {
      mensal: (15 * factor).toFixed(2),
      semestral: (50 * factor).toFixed(2),
      anual: (100 * factor).toFixed(2),
    };

    for (let key of Object.keys(points)) {
      let spl = points[key].split('.');

      if (spl[1] === '00') {
        points[key] = spl[0];
      }
    }

    return (
      <div>
        <div className={'level-2 d-flex ' + GDStyles['toYou']}>
          <div className={'d-flex justify-center flex-row ' + GDStyles['toYou__body']}>
            <div className={GDStyles['toYou__body_item']}>
              <h3 className={'p-xl-4 p-3'}>O que você ganha?</h3>
              <div className={'d-flex ' + GDStyles['wFull']}>
                <div className={'d-flex flex-column p-xl-4 p-3 ' + GDStyles['wHalfA']}>
                  <h2>Glampoints extras:</h2>
                  <p>
                    Quanto mais amigas assinarem, mais glampoints você ganha para trocar por
                    produtos incríveis no Glamclub.
                  </p>
                </div>
                <div className={'d-flex justify-between p-xl-4 p-3 ' + GDStyles['wHalfB']}>
                  <div className={GDStyles['glampointsTotal']}>
                    <Glampoints opacity={'0.1'} />
                    <div>
                      <strong>+ {points.anual} Glampoints</strong>
                      <span>Por plano anual</span>
                    </div>
                  </div>
                  <div className={GDStyles['glampointsTotal']}>
                    <Glampoints opacity={'0.1'} />
                    <div>
                      <strong>+ {points.semestral} Glampoints</strong>
                      <span>Por plano semestral</span>
                    </div>
                  </div>
                  <div className={GDStyles['glampointsTotal']}>
                    <Glampoints opacity={'0.1'} />
                    <div>
                      <strong>+ {points.mensal} Glampoints</strong>
                      <span>Por plano mensal</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              className={
                'p-xl-4 p-3 d-flex flex-row justify-between ' + GDStyles['toYou__body_item2']
              }
            >
              <h2>Ganha gifts exclusivos.</h2>
              <NavLink to={'/chama-as-amigas/concurso'} className={'btn btn-sm btn-light-pink'}>
                Confira aqui
              </NavLink>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

class ToYourFriends extends Component {
  state = {
    count: 0,
  };

  interval = null;

  componentDidMount() {
    this.getOpenData();
  }

  getOpenData = async () => {
    const { countdownTo } = this.props;

    const { result, statusCode } = await ExecuteRequest(GlamboxEndpoints.Open.open, null, 'GET');

    let date = new Date(countdownTo),
      time = date.getTime() - result;

    if (time > 0) {
      this.setState(
        {
          count: time,
        },
        () => {
          this.interval = setInterval(() => {
            this.setState(
              {
                count: Math.max(0, this.state.count - 1000),
              },
              () => {
                //this.renderCountDown();
                // if (this.state.count === 0) {
                //   clearInterval(this.interval);
                // }
              }
            );
          }, 1000);
        }
      );
    }
  };

  showGift = () => {
    return this.props.gift === true ? (
      <TagGift className={GDStyles['tag']} fill={'#0075e9'} text={'#ffffff'} size={26} />
    ) : (
      ''
    );
  };

  renderCountDown = () => {
    const { count } = this.state;

    let delta = Math.floor(count / 1000),
      days,
      hours,
      minutes,
      seconds,
      daysSpan,
      hoursSpan,
      minutesSpan,
      secondsSpan;

    days = Math.floor(delta / SECONDS_DAY);
    delta -= days * SECONDS_DAY;

    hours = Math.floor(delta / SECONDS_HOUR) % 24;
    delta -= hours * SECONDS_HOUR;

    minutes = Math.floor(delta / 60) % 60;
    delta -= minutes * 60;

    seconds = delta % 60;

    return (
      <span>
        <span className={'day'}></span>
      </span>
    );
  };

  noDiscountM() {
    return this.props.discountM === false ? (
      <div className={GDStyles['esgotado']}>Sem desconto</div>
    ) : (
      ''
    );
  }

  noDiscountS() {
    return this.props.discountS === false ? (
      <div className={GDStyles['esgotado']}>Sem desconto</div>
    ) : (
      ''
    );
  }

  noDiscountY() {
    return this.props.discountY === false ? (
      <div className={GDStyles['esgotado']}>Sem desconto</div>
    ) : (
      ''
    );
  }

  render() {
    const descontoAnual = this.props.anual ? this.props.anual : 60;
    const descontoSemestral = this.props.semestral ? this.props.semestral : 60;
    const descontoMensal = this.props.mensal ? this.props.mensal : 10;

    return (
      <div>
        <div
          className={classnames(
            'd-flex toYourFriends flex-column flex-lg-row',
            GDStyles['toYourFriends']
          )}
        >
          <div
            className={classnames(
              'p-xl-4 p-3 d-flex justify-center flex-column',
              GDStyles['header']
            )}
          >
            <h3>O que sua amiga ganha?</h3>
            <p>Descontos em todos os planos e gifts:</p>
          </div>
          <div
            className={classnames(
              GDStyles['glampointsTotal'],
              'p-xl-4 p-3 d-flex align-items-flex-start justify-center',
              GDStyles['discountBody']
            )}
          >
            {this.noDiscountY()}
            <div className={GDStyles['relative']}>
              {this.showGift()}
              <Discount2 fill={'#00e381'} />
            </div>
            <div>
              {/* <strong>R${descontoAnual} OFF</strong> */}
              <strong>R$100 OFF</strong>
              <span>Por plano anual</span>
            </div>
          </div>
          <div
            className={classnames(
              GDStyles['glampointsTotal'],
              'p-xl-4 p-3 d-flex align-items-flex-start justify-center',
              GDStyles['discountBody']
            )}
          >
            {this.noDiscountS()}
            <Discount2 fill={'#00e381'} />
            <div>
              <strong>R${descontoSemestral} OFF</strong>
              <span>Por plano semestral</span>
            </div>
          </div>
          <div
            className={classnames(
              GDStyles['glampointsTotal'],
              'p-xl-4 p-3 d-flex align-items-flex-start justify-center',
              GDStyles['discountBody']
            )}
          >
            {this.noDiscountM()}
            <Discount2 fill={'#00e381'} />
            <div>
              <strong>R${descontoMensal} OFF</strong>
              <span>Por plano mensal</span>
              <span className={GDStyles['glampointsTotal_caption']}>Tempo limitado</span>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export { ToYou, ToYourFriends };
